/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SuperAdminProfileDto = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    status: SuperAdminProfileDto.status;
    last_login_at?: string;
};
export namespace SuperAdminProfileDto {
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        PENDING = 'PENDING',
        VERIFICATION = 'VERIFICATION',
        SUSPENDED = 'SUSPENDED',
    }
}

